export default "__VITE_ASSET__C87jD5JN__"